import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Flex, Tag, Typography, theme } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { getReservationApprovalControlVisibility } from './reservationApprovalVisibility';
export var ReservationApprovalStatus = function (_a) {
    var reservationApproval = _a.reservationApproval, hasApprovalPermission = _a.hasApprovalPermission, permissionLoading = _a.permissionLoading, showApprovalButtons = _a.showApprovalButtons, setShowApprovalButtons = _a.setShowApprovalButtons, submittingApproval = _a.submittingApproval, onApprove = _a.onApprove, onOpenRejectModal = _a.onOpenRejectModal;
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var pendingApproval = reservationApproval.approved === null;
    var approvalTag = useMemo(function () {
        var approvalStatusColor = reservationApproval.approved === null
            ? {
                text: t("eventDetails.request.pending"),
                bg: token.colorWarningBg,
                border: token.colorWarningBorder,
            }
            : reservationApproval.approved
                ? {
                    text: t("eventDetails.request.approved"),
                    bg: token.colorSuccessBg,
                    border: token.colorSuccessBorder,
                }
                : {
                    text: t("eventDetails.request.rejected"),
                    bg: token.colorErrorBg,
                    border: token.colorErrorBorder,
                };
        return (_jsx(Tag, { variant: "outlined", style: {
                backgroundColor: approvalStatusColor.bg,
                color: token.colorText,
                borderColor: approvalStatusColor.border,
                marginInlineEnd: 0,
            }, children: approvalStatusColor.text }));
    }, [reservationApproval.approved, t, token]);
    var _b = getReservationApprovalControlVisibility({
        pendingApproval: pendingApproval,
        hasApprovalPermission: hasApprovalPermission,
        permissionLoading: permissionLoading,
        showApprovalButtons: showApprovalButtons,
    }), showEditApprovalControl = _b.showEditApprovalControl, showActionButtons = _b.showActionButtons;
    return (_jsxs(_Fragment, { children: [_jsxs(Flex, { align: "center", gap: 4, vertical: false, style: { justifyContent: 'space-between' }, children: [_jsx(Typography.Text, { style: { marginBottom: 0 }, children: t('eventDetails.request.request_status') }), _jsxs(Flex, { gap: 4, align: "center", justify: "center", children: [approvalTag, showEditApprovalControl && (_jsx(Button, { type: "text", icon: _jsx(FontAwesomeIcon, { icon: faPen }), onClick: function () { return setShowApprovalButtons(true); } }))] })] }), showActionButtons && (_jsxs(Flex, { gap: 8, vertical: false, style: { justifyContent: 'space-between' }, children: [_jsx(Button, { type: "primary", style: { width: '100%' }, loading: submittingApproval, onClick: onApprove, children: t('eventDetails.request.approve') }), _jsx(Button, { type: "default", danger: true, style: { width: '100%' }, loading: submittingApproval, onClick: onOpenRejectModal, children: t('eventDetails.request.reject') })] }))] }));
};
